// src/apiConfig.js

// This checks your .env file for the AWS IP. 
// If it's not there (like on your local Windows PC), it defaults to localhost.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://unl-online-retail-facility.com';

// You can also export specific endpoints to keep things even cleaner
export const API_ENDPOINTS = {
    PRODUCTS: `${API_BASE_URL}/api/request`,
    EXPERIMENTS: `${API_BASE_URL}/api/experiments`,
    ORDERS: `${API_BASE_URL}/api/all-orders`,
    TRACK_EVENT: `${API_BASE_URL}/api/track-event`,
};
